import {
  loadGalleryAssets,
  setOnBatch,
  setOnComplete,
  setOnError,
} from './inspiration-gallery/widen-gallery-api';
import {
  renderLoading,
  renderGrid,
  renderMessage,
  bindGridClicks,
  bindFilterInteractions,
  openFromHash,
} from './inspiration-gallery/gallery-ui';

const initInspirationGallery = () => {
  const root = document.getElementById('media-gallery-root');
  if (!root) {
    return;
  }

  let clicksBound = false;

  renderLoading();

  setOnBatch((items) => {
    renderGrid(items);
    if (!clicksBound) {
      bindGridClicks();
      bindFilterInteractions();
      clicksBound = true;
    }
  });

  setOnComplete((items) => {
    renderGrid(items, { filtersComplete: true });
    if (!clicksBound) {
      bindGridClicks();
      bindFilterInteractions();
      clicksBound = true;
    }
    openFromHash(items);
  });

  setOnError((message) => {
    renderMessage(message || 'Unable to load gallery images.');
  });

  loadGalleryAssets();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInspirationGallery);
} else {
  initInspirationGallery();
}
